import "./style";
import { render } from "preact";
import { useState } from "preact/hooks";

import baseImg from "./assets/base.jpg";
import eyesImg from "./assets/eyes.png";
import mouthImg from "./assets/mouth.png";
import noseImg from "./assets/nose.png";

import allLabel from "./assets/labels/all.svg";
import allBoldLabel from "./assets/labels/all-bold.svg";
import clearLabel from "./assets/labels/clear.svg";
import eyesLabel from "./assets/labels/eyes.svg";
import eyesBoldLabel from "./assets/labels/eyes-bold.svg";
import mouthLabel from "./assets/labels/mouth.svg";
import mouthBoldLabel from "./assets/labels/mouth-bold.svg";
import noseLabel from "./assets/labels/nose.svg";
import noseBoldLabel from "./assets/labels/nose-bold.svg";

const MenuImage = ({ src, onClick, boldSrc, active }) => (
  <img
    className="menu-item"
    src={active && boldSrc ? boldSrc : src}
    onClick={onClick}
  />
  // <div
  //   className="menu-item"
  //   dangerouslySetInnerHTML={{ __html: active && boldSrc ? boldSrc : src }}
  //   onClick={onClick}
  // />
);

const Image = ({ src, hidden }) => (
  <img className={"image" + (hidden ? " hidden" : "")} src={src} alt="base" />
);

const App = () => {
  const [state, setState] = useState({
    nose: false,
    eyes: false,
    mouth: false,
  });

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <Image src={baseImg} />
      <Image src={eyesImg} hidden={!state.eyes} />
      <Image src={noseImg} hidden={!state.nose} />
      <Image src={mouthImg} hidden={!state.mouth} />

      <div
        style={{
          width: "100%",
          position: "absolute",
          display: "flex",
          padding: "20px 10px",
          boxSizing: "border-box",
          justifyContent: "space-between",
          top: 0,
        }}
      >
        <MenuImage
          src={clearLabel}
          onClick={() => setState({ nose: false, eyes: false, mouth: false })}
        />
        <MenuImage
          src={eyesLabel}
          boldSrc={eyesBoldLabel}
          active={state.eyes}
          onClick={() => setState({ ...state, eyes: !state.eyes })}
        />
        <MenuImage
          src={noseLabel}
          boldSrc={noseBoldLabel}
          active={state.nose}
          onClick={() => setState({ ...state, nose: !state.nose })}
        />
        <MenuImage
          src={mouthLabel}
          boldSrc={mouthBoldLabel}
          active={state.mouth}
          onClick={() => setState({ ...state, mouth: !state.mouth })}
        />

        <MenuImage
          src={allLabel}
          boldSrc={allBoldLabel}
          active={state.mouth && state.nose && state.eyes}
          onClick={() => setState({ nose: true, eyes: true, mouth: true })}
        />
      </div>
    </div>
  );
};

if (typeof window !== "undefined") {
  render(<App />, document.getElementById("root"));
}



// WEBPACK FOOTER //
// ./index.js